<template>
  <div>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" v-if="show">
      <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-xl" role="document">
        <div class="modal-content" style="height:80vh;">
          <div class="modal-header">
            <h5 class="modal-title" id="timelineQueryEditorLabel">
              <i class="bi bi-cloud-sun me-2"></i>
              Weather Query
            </h5>
            <button type="button" class="btn-close" @click="$emit('cancel')" aria-label="Close"></button>
          </div>
          <div class="modal-body overflow-auto">
            <QueryEditor
              ref="queryEditor"
              :queryDefinition="localQueryDefn"
              :startSection="startSection"
            />
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="$emit('cancel')">Cancel</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="saveQuery"
            >Ok</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import QueryEditor from '../QueryEditor.vue';

export default {
  name: 'TimelineQueryEditor',
  components: {
    QueryEditor
  },
  props: {
    queryDefinition: {
      type: Object,
      required: true
    },
    startSection: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
  },
    data() {
        return {
        localQueryDefn: {},
        };
    },
    emits: ['save', 'cancel'],
    methods: {
        initializeConfigs() {
            // Deep clone the input configs
            Object.assign(this.localQueryDefn, JSON.parse(JSON.stringify(this.queryDefinition || {})));
            console.log("Initialized localQueryDefn:", this.localQueryDefn);
        },
        saveQuery() {
            // getQueryDefn() should be a method on QueryEditor
            const defn = this.$refs.queryEditor.getQueryDefn();
            this.$emit('save', defn);
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.initializeConfigs();
            }
        },
        queryDefinition: {
            handler(newVal) {
                if (this.show) {
                this.initializeConfigs();
                }
            },
            deep: true
        }
    },
    mounted() {
        if (this.show) {
            this.initializeConfigs();
        }
    },
};
</script>

<style scoped>
.modal-content {
  height: 80vh;
}
</style>